import React, { Component } from 'react';
import {observer} from 'mobx-react';
import * as mobx from 'mobx'
import appstore from '../store/apprdoc-store';
import { Form, Input, TextArea, Checkbox, Button } from 'semantic-ui-react'
import eb from '../utils/EventBus';


class ApprDocDetail extends Component {
	
	componentDidMount() {
		const { match } = this.props;
		appstore.loadApprDoc(match.params.id);
		appstore.getOrgUser();
		eb.on('doc updated', () => this.props.history.push('/approvedoc'));
	}

	
  render() {
		const doc = appstore.selectedDoc;
		const newComment = appstore.newComment;

    return (
       <div className="buyer-invoice">
                <div>
					<h4 align="left">Document Detail</h4>
				</div>
				{doc && (
					<Form>
					
						<Form.Field inline className="w-100 mb-2">
                            <section className="left-float">

							<label className="font-weight-600">Document Name</label>
							<Input  className="w-100 mb-2"  readOnly value={doc.docname}/>
							</section>

                            <Button className="right-float" primary onClick={appstore.dwnld}> Download Latest version </Button>
						</Form.Field>
						<Form.Field inline>
							<label>Document Description</label>
							<Input  className="w-100" readOnly value={doc.docdescr}/>
						</Form.Field>

						
						<Form.Field inline>
							<label>Creation Date</label>
							<Input  className="w-100" readOnly value={doc.creationdate}/>
						</Form.Field>

						<Form.Field inline>
							<label>Created By</label>
							<Input  className="w-100" readOnly value={doc.createdby}/>
						</Form.Field>
						
						
						<Form.Field inline>
							<label>Existing Comments</label>
							<TextArea  className="w-100" readonly value={doc.comments}/>
						</Form.Field>

						<Form.Field inline>
							<label>Enter new comment here</label>
							<TextArea  className="w-100" input type="text" value = {newComment} onChange={ (evt, { value }) => appstore.setNewComments(value)}/>
						</Form.Field>

						<Form.Field inline>
							<label>Tags</label>
							<TextArea  className="w-100" input type="text" value = {doc.tag} onChange={ (evt, { value }) => appstore.setTag(value)}/>
						</Form.Field>

						<Button  className="save" primary onClick={appstore.updApprDoc}>Save</Button>
						
					</Form>
				)}
				<div className="footer">
					
				</div>
		  </div>				
		
    );
  }
}


export default observer(ApprDocDetail);



// WEBPACK FOOTER //
// ./src/containers/ApprDocDetail.js